import { array, object, string } from "yup"

const internationalPhoneNumber = () =>
  string()
    .trim()
    .transform((v) => v.replace(/[^+0-9]_/g, ""))
    .matches(
      /\+[0-9]{1,3}[0-9]{4,14}/g,
      "Mobile Number format: +(country code, 1–3 digits) (phone number, 4–14 digits). Example: Country code: +01 and phone number: 123 1234 should be entered as +011231234"
    )

// Strips exactly what Ruby's String#strip strips: ASCII whitespace, and NOT
// U+00A0. yup's own .trim() delegates to JS String#trim, which DOES eat U+00A0,
// so a contact email padded with a non-breaking space passed this guard and was
// then rejected server-side by Identity::ValidatesContactEmailAddresses (whose
// Shoretime::Types::EMAIL_FORMAT treats U+00A0 as whitespace). The operator saw
// nothing at all, because updateOperatorDetails.rejected (Slice.ts) only clears
// `submitting`. Stripping the same characters as the backend keeps the two
// guards' verdicts identical, so a rejection is always caught here where it has
// a visible message.
const ASCII_EDGE_WHITESPACE = /^[\t\n\v\f\r ]+|[\t\n\v\f\r ]+$/g

const stripAsciiEdgeWhitespace = (value: unknown) =>
  typeof value === "string" ? value.replace(ASCII_EDGE_WHITESPACE, "") : value

export const CONTACT_TYPE_VALUES = ["business", "reservation", "administrative", "financial"]

export const ContactSchema = object({
  firstName: string().trim().required().label("First Name"),
  lastName: string().trim().required().label("Last Name"),
  jobTitle: string().trim().required().label("Job Title"),
  emailAddress: string()
    .transform(stripAsciiEdgeWhitespace)
    .email()
    .required()
    .label("Email Address"),
  phoneNumber: internationalPhoneNumber().required().label("Phone Number"),
  mobileNumber: internationalPhoneNumber().required().label("Mobile Number"),
  contactType: string().required().oneOf(CONTACT_TYPE_VALUES).label("Contact Type"),
})

export const OperatorFormSchema = object({
  name: string().required(),
  registrationNumber: string(),
  vatNumber: string(),
  address: string().required(),
  contacts: array().of(ContactSchema),
})
